import { refreshSession } from './RefreshSession';

/**
 * Service to handle post-payment user session refresh
 */
class PaymentSuccessService {
  /**
   * Refresh user session to get updated groups after payment
   * @param {Function} setUser
   * @param {Function} setGroups
   */
  async refreshUserSession(setUser, setGroups) {
    try {
      await new Promise(resolve => setTimeout(resolve, 2000));

      const session = await refreshSession({ forceRefresh: true });

      if (session.tokens) {
        const userInfo = session.tokens.idToken.payload;
        const userGroups = userInfo['cognito:groups'] || [];

        setUser(userInfo);
        setGroups(userGroups);

        this.showUpgradeSuccessMessage(userGroups);
      }
    } catch (error) {
      console.error('Error refreshing user session:', error);
    }
  }

  /**
   * Show success message based on new user group
   * @param {Array} groups
   */
  showUpgradeSuccessMessage(groups) {
    let planName = 'Unknown';

    if (groups.includes('ROLE_STANDARD')) {
      planName = 'Standard Plan';
    } else if (groups.includes('ROLE_PROFESSIONAL')) {
      planName = 'Professional Plan';
    }
  }

  /**
   * Extract session ID from URL parameters
   * @param {URLSearchParams} searchParams
   * @returns {string|null}
   */
  getSessionIdFromUrl(searchParams) {
    return searchParams.get('session_id');
  }

  /**
   * Verify payment session with backend (optional)
   * @param {string} sessionId
   * @returns {Promise<Object>}
   */
  async verifyPaymentSession(sessionId) {
    if (!process.env.REACT_APP_PAYMENTS_API_URL) {
      console.error('REACT_APP_PAYMENTS_API_URL is not configured');
      return null;
    }

    try {
      const response = await fetch(`${process.env.REACT_APP_PAYMENTS_API_URL}/verify-session`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ sessionId }),
      });

      if (response.ok) {
        return await response.json();
      } else {
        const errorData = await response.json().catch(() => ({ error: 'Unknown error' }));
        throw new Error(errorData.error || 'Failed to verify payment session');
      }
    } catch (error) {
      console.error('Error verifying payment session:', error);
      return null;
    }
  }
}

export default new PaymentSuccessService();
